/** @format */

import {
  AreaChart as RechartsAreaChart,
  Area,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from 'recharts';

interface Props {
  data: {
    name: string;
    amount: number;
  }[];
  height?: number;
  strokeColor?: string;
  fillColor?: string;
  gradientId?: string;
}

const SimpleAreaChart = ({
  data,
  height = 80,
  strokeColor = '#419466',
  fillColor,
  gradientId = 'simple-gradient',
}: Props) => {
  return (
    <ResponsiveContainer width='100%' height={height}>
      <RechartsAreaChart data={data} margin={{top: 5, right: 0, left: 0, bottom: 0}}>
        {fillColor && (
          <defs>
            <linearGradient id={gradientId} x1='0' y1='0' x2='0' y2='1'>
              <stop offset='0%' stopColor={fillColor} stopOpacity={0.3} />
              <stop offset='100%' stopColor={fillColor} stopOpacity={0} />
            </linearGradient>
          </defs>
        )}
        <XAxis dataKey='name' hide />
        <YAxis hide domain={['dataMin', 'dataMax']} />
        <Area
          type='monotone'
          dataKey='amount'
          stroke={strokeColor}
          strokeWidth={2}
          fill={fillColor ? `url(#${gradientId})` : 'transparent'}
          animationDuration={300}
        />
      </RechartsAreaChart>
    </ResponsiveContainer>
  );
};

export default SimpleAreaChart;

